import React from 'react';
import styled from 'styled-components';

import { useStateContext } from '../../context';
import { calcDistanceKm, getAppointmentUrl } from '../../utils';
import { StoreCard } from '../StoreCard';
import { useTranslation } from 'react-i18next';

interface IProps {
    className?: string;
}

const BaseInfoWindow: React.FC<IProps> = ({ className }) => {
    const { searchLocation, selectedStore } = useStateContext();
    const {
        i18n: { language },
    } = useTranslation();

    if (!selectedStore) return null;

    if (searchLocation) {
        selectedStore.distanceKm = calcDistanceKm(
            {
                lat: selectedStore.lat,
                lng: selectedStore.lng,
            },
            searchLocation
        );
    }

    const handleClickStore = () => {
        const appointmentUrl = getAppointmentUrl(selectedStore.globalId);

        window.open(
            language === 'fr' ? appointmentUrl.fr : appointmentUrl.nl,
            '_blank'
        );
    };

    return (
        <div className={className}>
            <StoreCard
                hideDistance
                store={selectedStore}
                onClick={handleClickStore}
            />
        </div>
    );
};

export const InfoWindow = styled(BaseInfoWindow)`
    min-width: 250px;

    ${StoreCard} {
        background-color: ${({ theme }) => theme.palette.background.paper};
        margin: 0;

        :hover {
            border: 2px solid transparent;
        }
    }
`;
